<template>
    <!-- Importing Home Component -->
    <OldCommisionComp></OldCommisionComp>
  </template>
  <script>
  import OldCommisionComp from "../components/OldCommisionReport.vue";
  
  export default {
    name: "Commission Report",
    components: { OldCommisionComp },
    computed: {},
    mounted() {},
  };
  </script>
  